import ApiService from '@/core/services/ApiService';
import { Module, Action, Mutation, VuexModule } from 'vuex-module-decorators';
import { Actions, Getters, Mutations } from '@/store/enums/PlanEnums';
import { PlanModuleStore, StoreError } from '@/models/StoreModel';
import { Plan } from '@/models/PlanModel';

@Module
export default class PlanModule extends VuexModule implements PlanModuleStore {
  actionError: StoreError | null = null;

  listPlans = [];
  planProduct = null;

  /**
   * Get local plan
   * @returns array
   */
  get [Getters.GET_PLAN](): any {
    return this.listPlans;
  }

  /**
   * Get products
   * @returns array
   */
  get [Getters.GET_PLAN_PRODUCT](): Plan {
    return this.planProduct as unknown as Plan;
  }

  @Mutation
  [Mutations.SET_PLAN](plans) {
    this.listPlans = plans;
  }

  @Mutation
  [Mutations.SET_PLAN_PRODUCT](product) {
    this.planProduct = product;
  }

  /**
   * Get errors
   * @returns array
   */
  get [Getters.GET_ACTION_ERROR](): StoreError {
    return this.actionError as StoreError;
  }

  @Mutation
  [Mutations.SET_ACTION_ERROR](error) {
    this.actionError = error;
  }

  @Action
  [Actions.PLAN]() {
    return new Promise<void>((resolve, reject) => {
      ApiService.get('agent/account/plans?returnAll=true')
        .then(({ data }) => {
          console.log(data);
          this.context.commit(Mutations.SET_PLAN, data.data);
          resolve();
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ACTION_ERROR, response);
          reject();
        });
    });
  }

  @Action
  [Actions.FETCH_PLAN_PRODUCT](payload) {
    ApiService.parameters(payload);

    return new Promise<void>((resolve, reject) => {
      ApiService.get('agent/products')
        .then(({ data }) => {
          this.context.commit(Mutations.SET_PLAN_PRODUCT, data.data);
          resolve();
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ACTION_ERROR, response);
          reject();
        });
    });
  }
}
